module.exports = __webpack_public_path__ + "static/media/estudio-televisão.71c6e61d.jpg";